module.exports = __webpack_public_path__ + "img/dashboard.be3c7bd3.jpeg";